import React, { useState, useEffect } from 'react';
import PropertyForm from './PropertyForm';
import PropertyCard from '../components/PropertyCard';
import { useAuth } from '../auth/AuthContext';
import { loadInitialProperties, saveProperties, generateNewId } from '../utils/propertyStorage';

const AdminDashboard = () => {
  const { currentUser, logout } = useAuth();
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const loadedProperties = loadInitialProperties();
    setProperties(loadedProperties);
  }, []);

  const handleAddProperty = (newProperty) => {
    const propertyToAdd = {
      ...newProperty,
      id: generateNewId(),
      agent: {
        name: "Admin Agent",
        email: "admin@nekretnine.com",
        phone: "+385 99 999 9999"
      }
    };
    
    const updatedProperties = [...properties, propertyToAdd];
    setProperties(updatedProperties);
    saveProperties(updatedProperties);
  };

  const handleDeleteProperty = (id) => {
    const updatedProperties = properties.filter(property => property.id !== id);
    setProperties(updatedProperties);
    saveProperties(updatedProperties);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>Admin sučelje</h2>
        <div style={styles.userInfo}>
          <span>Prijavljeni ste kao: {currentUser?.name}</span>
          <button onClick={logout} style={styles.logoutButton}>Odjava</button>
        </div>
      </div>

      <div style={styles.sections}>
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Dodaj novu nekretninu</h3>
          <PropertyForm onAddProperty={handleAddProperty} />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Upravljanje nekretninama ({properties.length})</h3>
          {properties.length === 0 ? (
            <p style={styles.emptyMessage}>Nema nekretnina</p>
          ) : (
            <div style={styles.propertiesGrid}>
              {properties.map(property => (
                <div key={property.id} style={styles.propertyCardWrapper}>
                  <PropertyCard property={property} />
                  <button 
                    onClick={() => handleDeleteProperty(property.id)}
                    style={styles.deleteButton}
                  >
                    Izbriši
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
    paddingBottom: '1rem',
    borderBottom: '1px solid #eee'
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  logoutButton: {
    padding: '8px 16px',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  sections: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '2rem'
  },
  section: {
    backgroundColor: '#fff',
    padding: '1.5rem',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
  },
  sectionTitle: {
    marginBottom: '1.5rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #eee'
  },
  emptyMessage: {
    textAlign: 'center',
    color: '#777',
    padding: '2rem'
  },
  propertiesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '1.5rem'
  },
  propertyCardWrapper: {
    position: 'relative'
  },
  deleteButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    padding: '5px 10px',
    backgroundColor: 'rgba(231, 76, 60, 0.8)',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    zIndex: 10
  }
};

export default AdminDashboard;